import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { mapState, mapActions } from 'vuex'

Vue.config.productionTip = false

//* Allow debugging for all environments
Vue.config.devtools = true
Vue.config.debug = true
Vue.config.silent = false

new Vue({
  router,
  store,
  vuetify,
  data() {
    return {
      validationRules: {
        numeric: value => {
          if (value == null || value === "" || value === 0) return true;
          if (!value) return 'Must be numeric';
          if (isNaN(value)) return 'Must be numeric';
          return true;
        },
        numericSelect: value => {
          if (!value) return 'Required';
          if (isNaN(value)) 'Required';
          return true;
        },
        requiredMultiselect: value => {
          if ( !value ) return "Required";
          if (value.length > 0) return true;
          else return "Required";
        },
        required: value => {
          if (value === 0) return true;
          if (!value) return 'Required';
          if (typeof value === 'string' && value.trim()) return true;
          if (isNaN(value)) return 'Required';
          return true;
        },
        boolean: value => {
          if (value == null) return 'Required';
          if (typeof value === 'boolean') return true;
          return 'Required';
        },
        greaterThanZero: value => {
          let theNum = parseFloat(value);
          if (Object.is(theNum, NaN)) return true;
          if (theNum > 0) return true;
          return 'Must be greater than 0';
        },
        noSpacesAllowed: value => {
          if (!value) return true;
          if (value.indexOf(" ") == -1) return true;
          return 'Spaces not allowed';
        }
      }
    }
  },
  computed: {
    ...mapState(["settings"])
  },
  render: h => h(App),
  async created() {
    try {
      window.addEventListener("error", this.handleUncaughtError);
      window.addEventListener("online", this.onlineStatusChanged);
      window.addEventListener("offline", this.onlineStatusChanged);

      await this.initializeStore();

      this.$vuetify.theme.dark = this.settings.isDarkMode;
      this.$mount("#app");
    } catch (error) {
      const errorMsg = `Store Initialization failed. ${error}`;
      alert(errorMsg);
      this.$vuetify.theme.dark = this.settings.isDarkMode;
      this.$mount("#app");
    }
  },
  errorCaptured(error) {
    this.showNoticeError(error.message);
  },
  beforeDestroyed() {
    window.removeEventListener("error", this.handleUncaughtError);
    window.removeEventListener("online", this.onlineStatusChanged);
    window.removeEventListener("offline", this.onlineStatusChanged);
  },
  methods: {
    ...mapActions(["setOnlineStatusInStore", "initializeStore"]),
    downloadCsvLocal(filename, data) {
      var a = document.createElement("a");
      a.download = filename;

      var blob  = new Blob([data], {type: "text/csv"});

      a.href = window.URL.createObjectURL(blob);
      a.click();
      a.remove();
    },
    handleUncaughtError(event) {
      this.showNoticeError(event.message);
      return true;
    },
    onlineStatusChanged() {
      this.setOnlineStatusInStore(navigator.onLine);
    }, 
    showNoticeError(text, closeCallback) {
      window.dispatchEvent(new CustomEvent('iag-show-notice', {
        detail:{text: text, on: true, noticeType: 'error', closeCallback: closeCallback}
      }));
      if (this.settings.isErrorSoundEnabled) {
        const audio = new Audio('sound/error-beep.mp3');
        audio.play();
      }
    },
    showNoticeWarning(text) {
      window.dispatchEvent(new CustomEvent('iag-show-notice', {
        detail:{text: text, on: true, noticeType: 'warning'}
      }));
    },
    showNoticeInfo(text) {
      window.dispatchEvent(new CustomEvent('iag-show-notice', {
        detail: {text: text, on: true, noticeType: 'info'}
      }));
    },
    showNoticeSuccess(text) {
      window.dispatchEvent(new CustomEvent('iag-show-notice', {
          detail: {text: text, on: true, noticeType: 'success'}
      }));
    },
    waitAsync(ms) {
      return new Promise(resolve => {
        setTimeout(resolve, ms);
      });
    }
  }
}).$mount('#app')